import { Component } from "@theme/component";

const ANCHORED_POPOVER_COMPONENT = "anchored-popover-component";

/**
 * Displays volume pricing information in a popover.
 * Shows quantity rules and pricing tiers with the current tier highlighted.
 * Positioning and hover behavior is handled by the parent anchored-popover-component.
 *
 * @typedef {Object} VolumePricingInfoRefs
 * @property {HTMLElement} popover - The popover element
 *
 * @extends {Component<VolumePricingInfoRefs>}
 */
class VolumePricingInfoComponent extends Component {
  /**
   * Ensures the parent anchored-popover-component refs are refreshed after connection,
   */
  connectedCallback() {
    super.connectedCallback();
    const anchoredPopover = this.closest(ANCHORED_POPOVER_COMPONENT);
    if (anchoredPopover instanceof Component && anchoredPopover.isConnected) {
      try {
        anchoredPopover.updatedCallback();
      } catch {
        Promise.resolve()
          .then(() => {
            if (anchoredPopover.isConnected) {
              try {
                anchoredPopover.updatedCallback();
              } catch {
                // Ignore error
              }
            }
          })
          .catch(() => {
            // Ignore error
          });
      }
    }
  }

  /**
   * Ensures the parent anchored-popover-component refs are refreshed immediately,
   */
  updatedCallback() {
    super.updatedCallback();
    const anchoredPopover = this.closest(ANCHORED_POPOVER_COMPONENT);
    if (anchoredPopover instanceof Component) {
      anchoredPopover.updatedCallback();
    }
  }
}

if (!customElements.get("volume-pricing-info")) {
  customElements.define("volume-pricing-info", VolumePricingInfoComponent);
}
